import * as React from 'react';
var CascaderContext = /*#__PURE__*/React.createContext({});
export default CascaderContext;